module.exports = ".header-bg{\n    background-image: url('404.jpg');\n}"